import React from 'react';
import { Suspense, useEffect, useState } from 'react';

import { Canvas } from '@react-three/fiber';
import { OrbitControls, Preload, useGLTF } from '@react-three/drei';

import CanvasLoader from '../Loader';

const Computers = ({ isMobile }) => {

  //const computer = useGLTF('./desktop_pc/scene.gltf')

  const computer = useGLTF('./gaming_desktop_pc/scene.gltf')

  return (
    <mesh>
      <hemisphereLight intensity={4.25}
      groundColor="black"/>
      <pointLight intensity={1} />
      <spotLight
        position={[-20, 50, 10]}
        angle={0.12}
        penumbra={1}
        intensity={1}
        castShadow
        shadow-mapSize={1024}
       />
      <primitive 
        object={computer.scene}
        scale={ isMobile ? 0.7 : 0.75}
        position={ isMobile ? [0, -3, -2.2] : [0, -3.15, -1.5]}
        rotation={[0, 0, 0]}
      />
    </mesh>
  )
}

export default function ComputersCanvas () {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    //Add a listener for changes to the screen size
    const mediaQuery = window.matchMedia('(max-width: 500)');
    //Set the initial value of the 'isMobile' state variable
    setIsMobile(mediaQuery.matches);

     //Define the callback function to handle changes to the media query
    const handleMediaQueryChange = (event) => {
      setIsMobile(event.matches);
    }

   //Add the callback function as listener for changes to media query
    mediaQuery.addEventListener('change', handleMediaQueryChange);

    //Remove the listener when the component is unmounted
    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    }
  }, [])
  
  return (
    <Canvas 
      frameLoop='demand'
      shadows
      camera={{ position: [20, 3, 5], fov: 25 }}
      gl={{ preserveDrawingBuffer: true }}
    >
      <Suspense fallback={<CanvasLoader />}>
        <OrbitControls 
          enableZoom={false}
          maxPolarAngle={Math.PI / 2}
          minPolarAngle={Math.PI / 2}
        />
        <Computers isMobile={isMobile} />
      </Suspense>

      <Preload all/>
    </Canvas>
  )
}
